<button [matMenuTriggerFor]="templatesMenu" color="primary" mat-stroked-button>
  {{ 'QUERY_BUILDER.paste_template' | translate }}
</button>
<mat-menu #templatesMenu>
  @if (templates$ | async; as templates) {
    @if (!templates.length) {
      <div mat-menu-item>
        {{ 'QUERY_BUILDER.no_templates' | translate }}
      </div>
    }
    @for (template of templates; track template) {
      <div (click)="pasteTemplate(template)" class="templates" mat-menu-item>
        <div class="template-name">{{template.name}}</div>
        <mat-icon
          (click)="$event.stopPropagation()"
          [mdePopoverTriggerFor]="removePopover"
          class="remove-template-btn"
          [matTooltip]="'QUERY_BUILDER.delete_template' | translate"
          mdePopoverTriggerOn="click">
          delete_outline
        </mat-icon>
        <mde-popover
          #removePopover="mdePopover"
          [mdePopoverCloseOnClick]="true"
          [mdePopoverOverlapTrigger]="false"
          mdePopoverPositionY="below">
          <mat-card appearance="outlined">
            <p class="template-remove-message">{{ 'QUERY_BUILDER.confirm_delete_template' | translate }}</p>
            <div>
              <button color="warn" mat-button>{{ 'COMMON.cancel' | translate }}</button>
              <button (click)="removeTemplate(template)" color="primary" mat-button>{{ 'QUERY_BUILDER.delete' | translate }}</button>
            </div>
          </mat-card>
        </mde-popover>
      </div>
    }
  }
</mat-menu>
